export default "__VITE_ASSET__CO0O6nMB__"